/**
 * External dependencies
 */

import { get, values } from 'lodash';


export const getAllAddons = (state) => values(get(state, ['addons', 'items']));

export const requestingAddons = (state) => (get(state, ['addons', 'requesting']));

export const errorRequestingAddons = (state) => get(state, ['addons', 'error']);
